import { defaultUrlTransform, type Components } from 'react-markdown';

import { Markdown } from '@/components/ui/markdown';
import { MENTION_HREF_PREFIX, mentionsToLinks } from '../mention';

const keepMentionHrefs = (url: string) =>
  url.startsWith(MENTION_HREF_PREFIX) ? url : defaultUrlTransform(url);

const COMPONENTS: Components = {
  a: ({ href, children, node: _node, ...props }) =>
    href?.startsWith(MENTION_HREF_PREFIX) ? (
      <span className="text-primary font-medium">{children}</span>
    ) : (
      <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    ),
};

/**
 * A comment body: Markdown (plain text is valid Markdown) with line breaks kept
 * as typed and `@[Name](user:<id>)` tokens shown as "@Name". The API converts
 * HTML bodies to Markdown on write (DEV13-68), so tags never show raw.
 */
export function CommentBody({ body }: { body: string }) {
  return (
    <Markdown
      keepLineBreaks
      components={COMPONENTS}
      urlTransform={keepMentionHrefs}
      className="prose-p:my-1.5 prose-ul:my-1.5 prose-ol:my-1.5 prose-li:my-0.5 prose-pre:my-2 prose-headings:my-2 prose-code:before:content-none prose-code:after:content-none break-words"
    >
      {mentionsToLinks(body)}
    </Markdown>
  );
}
